<template>
  <v-form class='viewProjectForm' v-model='valid' ref='viewProjectForm'>
    <v-container class='mb-10'>
      <h4>Project Details</h4><hr />
      <v-row>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Project No : </label>
          <p>{{ project.serial_no ? project.serial_no : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Start Date : </label>
          <p v-if="project.start_date">{{ project.start_date | formatDate }}</p>
          <p v-else>-</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Estimated End Date : </label>
          <p v-if="project.estimated_end_date">{{ project.estimated_end_date | formatDate }}</p>
          <p v-else>-</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>End Date : </label>
          <p v-if="project.end_date">{{ project.end_date | formatDate }}</p>
          <p v-else>-</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Assigned WPS : </label>
          <p><v-chip small v-for="(item, index) in project.ptwp_id" :key="index">{{ item.text }}</v-chip> &nbsp;</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Remark : </label>
          <p>{{ project.remark ? project.remark : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Description : </label>
          <p>{{ project.description ? project.description : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Status : </label>
          <p>
            <template>
              <v-chip :color="getProjectStatus" class="white--text text-capitalize" small>{{ this.project.status}}</v-chip>
            </template>
          </p>
        </v-col>
      </v-row>
      <h4>Material Details</h4><hr />
      <v-row v-for="(pm, idx) in project.project_material" :key="idx" class="pt-2">
        <v-col cols="12" lg="11" md="11" sm="12" xs="12" class="py-0">
          <v-row>
            <v-col cols="12" md="3" sm="6" xs="12" class="pt-0">
              <label class='view_label'>Material </label>
              <p>{{ pm.material ? pm.material : '-' }}</p>
            </v-col>
            <v-col cols="12" md="3" sm="6" xs="12" class="pt-0">
              <label class='view_label'>Quantity </label>
              <p>{{ pm.quantity ? pm.quantity : '-' }}</p>
            </v-col>
            <v-col cols="12" md="3" sm="6" xs="12" class="pt-0">
              <label class='view_label'>Unit </label>
              <p>{{ pm.unit ? pm.unit : '-' }}</p>
            </v-col>
            <v-col cols="12" md="3" sm="6" xs="12" class="pt-0">
              <label class='view_label'>Price </label>
              <p>{{ pm.price ? pm.price : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-footer fixed>
        <v-col class="text-right">
          <v-btn v-if="$checkRight(['edit_project'])" color="primary" class="mr-2" @click="edit" small>Edit</v-btn>
          <!-- <v-btn color="primary" class="mr-2" @click="changeStatus(project.id,'open')" small v-if="project.status === 'pending'">Open</v-btn>
          <v-btn color="primary" class="mr-2" @click="changeStatus(project.id,'approved')" small v-if="project.status === 'open'">Approved</v-btn>
          <v-btn color="primary" class="mr-2" @click="changeStatus(project.id,'complete')" small v-if="project.status === 'approved'">Complete</v-btn> -->
        </v-col>
      </v-footer>
    </v-container>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  computed: {
    getProjectStatus () {
      let temp = ''
      if (this.project.status === 'pending') {
        temp = 'orange'
      } else if (this.project.status === 'open') {
        temp = 'green'
      } else if (this.project.status === 'approved') {
        temp = 'primary'
      } else if (this.project.status === 'in_active') {
        temp = '#FFC107'
      } else {
        temp = 'secondary'
      }
      return temp
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.$axios.post('getProjectById/' + id).then((res) => {
        const data = res.data.project
        data.project_material = res.data.project_material
        data.ptwp_id = res.data.ptwp
        this.project = data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    } else {
      this.edit_id = undefined
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      project: {},
    }
  },
  methods: {
    edit () {
      const editId = this.$route.params.id
      this.$router.push({ path: `/project/edit/${editId}`, })
    },
    changeStatus (id, status) {
      if (id) {
        this.$axios.post('changeStatus/' + id, { status: status }).then((res) => {
          this.project.status = res.data.status
        }).catch(() => {
          this.loading = false
          console.log('some error occurred')
        })
      } else {
        console.log('in else')
      }
    }
  }
}
</script>

<style>
.viewProjectForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.viewProjectForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.viewProjectForm .view_label {
  font-size: 15px;
  font-weight: bold;
}
</style>
